import { DOC_PATH, FOLDER_DOC_PATH } from 'paths'
import { generatePath, useHistory, useRouteMatch } from 'react-router-dom'
import { useRootStore } from 'stores/RootStore'

/**
 * This hook syncs the url with the updated article slug, maintaining the
 * correct route and all the query params.
 */
export const useSyncArticleSlug = (articleId: string) => {
  const { docStore } = useRootStore()
  const inFolder = useRouteMatch<{ folderSlug: string; doc?: string }>(FOLDER_DOC_PATH)
  const inDoc = useRouteMatch<{ slug: string }>(DOC_PATH)
  const history = useHistory()

  const syncArticleSlug = (newSlug: string) => {
    if (docStore?.articleId !== articleId) {
      return
    }

    if (inFolder) {
      history.replace({
        pathname: generatePath(FOLDER_DOC_PATH, { ...inFolder.params, doc: newSlug }),
        search: history.location.search,
      })
    }
    if (inDoc) {
      history.replace({
        pathname: generatePath(DOC_PATH, { ...inDoc.params, slug: newSlug }),
        search: history.location.search,
      })
    }
  }

  return syncArticleSlug
}
